import { Injectable } from '@angular/core';
import { write, utils, type WorkSheet, type WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  constructor() {}

  /**
   * (Array of Arrays) to Excel
   * @param data  [[...], [...]]
   * @param fileName
   * @param headers ['Col1', 'Col2']
   * @param footer ['Summary', 123, 456]
   */
  exportArrayOfArrays(
    data: any[][],
    fileName: string = 'export',
    headers?: string[],
    footer?: any[],
  ): void {
    const fullData = [
      ...(headers ? [headers] : []),
      ...data,
      ...(footer ? [footer] : []),
    ];

    const worksheet: WorkSheet = utils.aoa_to_sheet(fullData);
    const workbook: WorkBook = {
      Sheets: { Sheet1: worksheet },
      SheetNames: ['Sheet1'],
    };

    const excelBuffer: any = write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, `${fileName}.xlsx`);
  }
}
